import { Model, fields } from '@gasman/smush';

class Ornament extends Model([
    new fields.ListField(
        'tones',
        new fields.IntegerField('tone', { min: -64, max: 63, default: 0 }),
        { length: 32 },
    ),
]) {}

export { Ornament };
